module.exports = __webpack_public_path__ + "img/browse-vehicles-background-mitsu.cd27be4f.png";